import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "success", "emailInput", "emailDisplay", "submitBtn"]

  submit(event) {
    event.preventDefault()
    const email = this.emailInputTarget.value.trim()
    if (!email) return

    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "Sending..."

    // Simulate API call
    setTimeout(() => {
      this.emailDisplayTarget.textContent = email
      this.formTarget.classList.add("hidden")
      this.successTarget.classList.remove("hidden")
    }, 800)
  }
}
